<script lang="ts">
  import { onMount } from 'svelte'
  import { PUBLIC_HEAP_ID } from '$env/static/public'
  import { fade } from 'svelte/transition'
  import { resolve } from '$app/paths'

  let show = $state(false)

  const onShow = () => {
    show = true

    if (typeof window !== 'undefined') {
      window.document.body.classList.remove('overflow-hidden')
      window.document.body.classList.remove('h-screen')
    }
  }

  const onCloseShow = () => {
    show = false

    if (typeof window !== 'undefined') {
      window.document.body.classList.remove('overflow-hidden')
      window.document.body.classList.remove('h-screen')
    }
  }

  onMount(() => {
    if (typeof window !== 'undefined')
      if (!localStorage.getItem('consent-permissions')) {
        window.scrollTo({ behavior: 'smooth', top: 0 })

        window.document.body.classList.add('overflow-hidden')
        window.document.body.classList.add('h-screen')

        return onShow()
      }

    if (typeof window !== 'undefined')
      if (localStorage.getItem('consent-permissions') === 'ACCEPTED') {
        onCloseShow()
        loadAnalytic()
      }
  })

  const acceptCookie = () => {
    localStorage.setItem('consent-permissions', 'ACCEPTED')

    onCloseShow()

    return loadAnalytic()
  }

  const rejectCookie = () => {
    localStorage.setItem('consent-permissions', 'REJECTED')
    show = false

    if (typeof window !== 'undefined') {
      window.document.body.classList.remove('overflow-hidden')
      window.document.body.classList.remove('h-screen')
    }
  }

  const loadAnalytic = async () => {
    if (import.meta.env.PROD && typeof window !== 'undefined') {
      const documentHead = document.head
      const scriptHeapTag = document.createElement('script')

      // prettier-ignore
      scriptHeapTag.type = "text/javascript"

      // prettier-ignore
      scriptHeapTag.innerHTML = `
                window.heapReadyCb=window.heapReadyCb||[],window.heap=window.heap||[],heap.load=function(e,t){window.heap.envId=e,window.heap.clientConfig=t=t||{},window.heap.clientConfig.shouldFetchServerConfig=!1;var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="https://cdn.us.heap-api.com/config/"+e+"/heap_config.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(a,r);var n=["init","startTracking","stopTracking","track","resetIdentity","identify","getSessionId","getUserId","getIdentity","addUserProperties","addEventProperties","removeEventProperty","clearEventProperties","addAccountProperties","addAdapter","addTransformer","addTransformerFn","onReady","addPageviewProperties","removePageviewProperty","clearPageviewProperties","trackPageview"],i=function(e){return function(){var t=Array.prototype.slice.call(arguments,0);window.heapReadyCb.push({name:e,fn:function(){heap[e]&&heap[e].apply(heap,t)}})}};for(var p=0;p<n.length;p++)heap[n[p]]=i(n[p])};
                heap.load("${PUBLIC_HEAP_ID}", {
                    eventPropertiesStorage: 'cookies',
                    enableSecureCookies: true,
                });
            `

      documentHead.appendChild(scriptHeapTag)
    }
  }
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
{#if show}
  <div
    transition:fade
    class={`root-consent__dialog | fixed left-0 top-0 z-[9999] h-full w-full ${show ? 'block' : 'hidden'}`}
  >
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <div
      onclick={() => onCloseShow()}
      class="root-consent__backdrop | absolute z-[10] h-full w-full"
    ></div>

    <div
      class="content-consent__dialog | absolute bottom-0 left-1/2 z-20 h-auto w-full -translate-x-1/2 rounded-md bg-white shadow-md md:w-5/12 lg:bottom-8"
    >
      <div class="rounded-md bg-brand/10 p-6">
        <div class="flex flex-col items-end gap-6 lg:flex-row">
          <div>
            <p class="gray-800 mb-2 font-bold">Permisssões sobre Cookies</p>
            <p class="text-sm">
              Nós usamos cookies para analisar o tráfego e melhorar sua experiência. Ficaremos
              felizes por oferecer uma experiência única, Você aceita?.
            </p>
          </div>

          <div class="row | w-full justify-center gap-4 lg:w-auto">
            <button
              onclick={() => acceptCookie()}
              class="accept | w-full rounded-lg bg-brand px-6 py-3 text-white">Aceitar</button
            >
            <button
              onclick={() => rejectCookie()}
              class="reject | w-full rounded-lg bg-brand/40 px-6 py-3 text-white">Recusar</button
            >
          </div>
        </div>

        <hr class="my-3 border-brand-500/40" />

        <p class="text-sm">
          Para saber mais detalhes sobre a utilização deste dados por favor visite nossas <a
            class="text-brand underline"
            href={resolve('/(index)/politica-de-privacidade')}>Pólitica de privacidade.</a
          >
        </p>
      </div>
    </div>
  </div>
{/if}
